// extracted by mini-css-extract-plugin
module.exports = {"componentWrapper":"componentWrapper_3b75Mwog","tabbarWrapper":"tabbarWrapper_11GDO5Bf","tabbarIcon":"tabbarIcon_1NKQTd_Z"};